/**
 * Profanity filter for usernames.
 *
 * Two-pass approach:
 * 1. Strip separators (_/-) and check for substring matches against long,
 *    unambiguous terms that won't collide with normal English words.
 * 2. Split the original input on separators and check each segment against
 *    a broader exact-match list (includes shorter words like "ass" that
 *    would false-positive as substrings — e.g. "class").
 */

/** Words safe for substring matching (won't match normal words). */
const SUBSTRING_LIST: string[] = [
  'fuck',
  'shit',
  'bitch',
  'cunt',
  'nigger',
  'nigga',
  'faggot',
  'retard',
  'slut',
  'whore',
  'whor',
  'porn',
  'asshole',
  'dumbass',
  'jackass',
  'bastard',
  'motherfuck',
  'dickhead',
  'cocksucker',
  'twat',
];

/** Shorter words checked only as exact segments between separators. */
const EXACT_SEGMENT_LIST: string[] = [
  'ass',
  'cock',
  'cum',
  'tit',
  'tits',
  'dick',
  'piss',
  'rape',
  'nazi',
  'fag',
  'nig',
  'spic',
  'kike',
  'coon',
];

/**
 * Returns true if the given text contains profanity.
 *
 * @param text - raw username string (only [a-zA-Z0-9_-] expected)
 */
export const containsProfanity = (text: string): boolean => {
  if (!text) return false;

  const lower = text.toLowerCase();

  // Pass 1 — strip separators, substring check
  const stripped = lower.replace(/[_-]/g, '');
  if (SUBSTRING_LIST.some((word) => stripped.includes(word))) {
    return true;
  }

  // Pass 2 — split on separators, exact segment check
  const segments = lower.split(/[_-]/);
  if (segments.some((seg) => EXACT_SEGMENT_LIST.includes(seg))) {
    return true;
  }

  return false;
};
